exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2Do97-7_3_0 {\n  color: #282828;\n  font-size: 22px;\n  line-height: 32px;\n  letter-spacing: 0.15px;\n  font-weight: 500; }\n\n._2C5z2-7_3_0 {\n  color: #282828;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0.15px;\n  font-weight: 700; }\n\n._31BjR-7_3_0 {\n  color: #282828;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0.25px;\n  font-weight: 700; }\n", ""]);

// Exports
exports.locals = {
	"core-h1": "_2Do97-7_3_0",
	"core-h2": "_2C5z2-7_3_0",
	"core-h3": "_31BjR-7_3_0"
};